<p-card>
  <ng-template pTemplate="header">
    <div class="title-visualizacao"><span class="cl-blue">Tipo Movimento: </span>
      <span class="">{{tipoMovimento.nome}}</span>
    </div>
  </ng-template>
  <div class="p-fluid">
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
      <div class="p-col-12 p-md-10">{{tipoMovimento.id}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Nome:</label>
      <div class="p-col-12 p-md-10">{{tipoMovimento.nome}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Descrição: </label>
      <div class="p-col-12 p-md-10">{{tipoMovimento.descricao}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Permitido</label>
      <div class="p-col-12 p-md-10">
        <span [class]="'badge ' + (tipoMovimento.permitido ? 'badge-success' : 'badge-danger')">
          {{ tipoMovimento.permitido ? 'Sim' : 'Não' }}
        </span>
      </div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Situação: </label>
      <div class="p-col-12 p-md-10" *ngIf="tipoMovimento?.situacao === 'ATIVO'" class="badge badge-success m-l-8">Ativo</div>
      <div class="p-col-12 p-md-10" *ngIf="tipoMovimento?.situacao === 'INATIVO'" class="badge badge-danger m-l-8">Inativo</div>
    </div>
    <div class="p-field p-grid" *ngIf="tipoMovimentoHierarquia">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Hierarquia: </label>

      <div class="p-col-12 p-md-10">
        <span  *ngIf="tipoMovimentoHierarquia.length > 0">
        <span *ngFor="let tipoMovimentoHierarquia of tipoMovimentoHierarquia">
          <a (click)="this.limparHierarquia()" [routerLink]="['/tipoMovimento/visualizar', tipoMovimentoHierarquia.id]">
           {{replaceTextoHierarquia(tipoMovimentoHierarquia.nome)}}/
        </a>
        </span>
      </span>
      {{replaceTextoHierarquia(tipoMovimento.nome)}}
       </div>
    </div>
    <p-table
      [value]="tipoMovimento.complementos"
      dataKey="tipoComplemento.id">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem"></th>
          <th class="p-text-center">Id </th>
          <th pSortableColumn="tipoComplemento.categoria">Categoria <p-sortIcon field="tipoComplemento.categoria"></p-sortIcon></th>
          <th>Descrição</th>
          <th>Observação</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-tipoMovimentoComplemento let-expanded="expanded">
        <tr>
          <td>
            <button type="button" pButton pRipple [pRowToggler]="tipoMovimentoComplemento" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
          </td>
          <td class="p-text-center">{{tipoMovimentoComplemento.tipoComplemento.id }}</td>
          <td>{{tipoMovimentoComplemento.tipoComplemento.categoria }}</td>
          <td>{{tipoMovimentoComplemento.tipoComplemento.descricao }}</td>
          <td>{{tipoMovimentoComplemento.tipoComplemento.observacao }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-tipoMovimentoComplemento>
        <tr *ngIf="!tipoMovimentoComplemento.tipoComplemento.itens || tipoMovimentoComplemento.tipoComplemento.itens.length === 0">
          <td colspan="6">Não há informações para os ítens desta categoria.</td>
        </tr>
        <tr *ngIf="tipoMovimentoComplemento.tipoComplemento.itens  && tipoMovimentoComplemento.tipoComplemento.itens.length > 0">
          <td colspan="7">
           <div class="p-p-3">
              <p-table [value]="tipoMovimentoComplemento.tipoComplemento.itens" dataKey="item.id">
                <ng-template pTemplate="header">
                  <tr>
                    <th colspan="7" style="text-align: center">Dados de complementos</th>
                  </tr>
                  <tr>
                    <th pSortableColumn="id" width="120px" class="p-text-center">Id <p-sortIcon field="id"></p-sortIcon></th>
                    <th pSortableColumn="descricao">Descrição <p-sortIcon field="descricao"></p-sortIcon></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                  <tr>
                    <td  class="p-text-center">{{item.id}}</td>
                    <td>{{item.descricao}}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6"> Movimento sem complementos.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-col-12">
      <button pButton appBotaoVoltar class="p-button-primary p-lg-12" label="Voltar"></button>
    </div>
  </ng-template>
</p-card>
